import clsx from 'clsx'
import React from 'react'

import { Text } from '@wartek-id/text-v1'

type InfoCardProps = {
  icon: React.ReactNode
  title: string
  content: React.ReactNode
  button: React.ReactNode
  className?: string
}

const InfoCard = ({
  button,
  icon,
  content,
  title,
  className,
}: InfoCardProps) => {
  return (
    <div
      className={clsx(
        'bg-white p-6 rounded-lg shadow-sm border hover:shadow-md transition-shadow flex flex-col h-full',
        className
      )}
    >
      <div className="mb-3">{icon}</div>
      <div className="mb-2">
        <Text variant={'body-bold'}>{title}</Text>
      </div>
      <div className="flex-grow">{content}</div>
      <div>{button}</div>
    </div>
  )
}

export default InfoCard
